<template>
    <!-- 我的消息 -->
    <section class="container MsgM">
        <Header @loadPage="onload"></Header>
        <div class="wrapper">
            <div class="locationM text-left">
                <Breadcrumb>
                    <img class="img" src="../assets/location.png" alt="">
                    当前位置：
                    <BreadcrumbItem to="/">首页</BreadcrumbItem>
                    <BreadcrumbItem>学习指南</BreadcrumbItem>
                    <BreadcrumbItem>消息</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="innerM">
                <div class="title">
                    消息
                </div>
                <div class="inner-wrapper" v-if="$store.state.isLogin && isAlert == 1">
                    <div class="msg" v-for="(msg, index) in msgList" :key="index">
                        <div class="text-left msg_header">
                            {{msg.title}}
                        </div>
                        <div class="text-left msg_body">
                          {{msg.message}}
                        </div>
                        <div class="text-left msg_footer">
                            {{msg.createTime}}
                            <span v-if="msg.status == 0"> ( <span style="color: red"> 未读 </span> )</span>
                        </div>
                    </div>
                </div>
                <Alert class="alert" v-if="$store.state.isLogin && isAlert == -1" show-icon >
                  您目前没有接收到的消息
                  <template slot="desc">You are not currently receiving a message. </template>
                </Alert>
                <Alert class="alert" type="error" v-if="!$store.state.isLogin" show-icon>
                  您需要登录后才能查看该内容
                  <span slot="desc">You need to be logged in to view this content.</span>
                </Alert>
                <!--<div class="pageM" v-if="total >= 10">-->
                    <!--<Page :total="total" :current.sync="page" @on-change="pageClick"/>-->
                <!--</div>-->
            </div>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from './components/Header'
    import Footer from './components/Footer'
    export default {
        name: "Msg",
        data(){
            return {
                total: 10,
                page: 1,
                msgList: [],
                isAlert:'', //-1代表无消息，1代表有消息
            }
        },
        created(){
            var that = this;
            that.onload();
          this.setTab();
        },
        mounted(){
        },
        methods: {
            onload(){
                //初始化页面
                var that = this;
                var token =  that.$cookie.get('xjaf-token');
                var username =  that.$cookie.get('xjaf-user');
                if(token !=null && username !=null){
                    this.httprequest();
                }else{
                    this.$store.commit('login');
                }
            },
            httprequest(){
                //请求接口
                var that = this;
                var data = {
                  "page": that.page,
                  'size': 10
                };
                this.$http({
                    url: that.webhost + 'message/list',
                    method: 'POST',
                    data: data
                }).then(({data}) => {
                    if (data && data.code === 0) {
                        that.msgList = data.data.list;
                        if (that.msgList.length > 0  ){
                          that.isAlert = 1;
                        } else {
                          that.isAlert = -1;
                        }
                        for (var i = 0 ; i < data.data.list.length ; i++){
                          if(data.data.list[i].status == 0 ){
                            that.readmessage(data.data.list[i].messageId);
                          }
                        }

                    }else {
                        that.$Message.error(data.msg)
                        that.isAlert = -1;
                    }
                })
            },
            readmessage(messageId){
              var that = this;
              this.$http({
                url: that.webhost + 'message/read/'+ messageId,
                method: 'GET',
              }).then(({data}) => {
                console.log(data)

                if (data && data.code === 0) {
                //  消息已读
                }else {
                    that.$Message.error(data.msg)
                }
              })
            },
            pageClick(){
                this.httprequest();
            },
        },
        components: {
            Header,
            Footer
        }
    }
</script>

<style scoped>
    .wrapper{
        width: 1200px;
        min-width: 1200px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 90px;
        font-family: "PingFang SC";
    }
    .title{
        text-align: left;
        font-size: 25px;
        line-height: 72px;
        color: #000;
        border-bottom: solid 2px #ccc;
    }
    .locationM{
        height: 50px;
        line-height: 50px;
    }
    .locationM .ivu-breadcrumb{
        font-size: 15px;
        color: #000;
    }
    .locationM img{
        width: 23px;
        height: 22px;
        margin-right: 5px;
        position: relative;
        top: 3px;
    }
    .inner-wrapper{
        margin-bottom: 60px;
        min-height: 700px;
    }
    .msg{
        padding: 12px 0;
        border-bottom: solid 1px #cfd2d3;
    }
    .msg .msg_header{
        font-weight: bold;
        color: #000;
        font-size: 25px;
        line-height: 40px;
    }
    .msg .msg_body, .msg .msg_footer{
        color: #666;
        font-size: 17px;
        line-height: 30px;
    }
</style>

<style>
    .MsgM .ivu-page-item, .ivu-page-prev, .ivu-page-next{
        border-radius: 0;
    }
    .MsgM .ivu-page-item.ivu-page-item-active{
        background: #0070bd;
    }
    .MsgM .ivu-page-item-active a{
        color: #fff;
    }
    .MsgM .el-checkbox__label{
        display: none;
    }
    .MsgM .el-checkbox__inner{
        border-radius: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/views/Msg.vue